import { render } from "./Dates.vue?vue&type=template&id=3e59ca4a"
import script from "./Dates.vue?vue&type=script&lang=js"
export * from "./Dates.vue?vue&type=script&lang=js"

import "./Dates.vue?vue&type=style&index=0&id=3e59ca4a&lang=scss"
script.render = render

export default script